import { Box, Button, Container, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import useLogin from "../hooks/useLogin";
import { Link } from "react-router-dom";

const Login = () => {
  const { login } = useLogin();
  const [user, setUser] = useState({ username: "", password: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const handleClickLogin = () => {
    login(user);
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h5">ログイン画面</Typography>
        <TextField
          margin="normal"
          required
          fullWidth
          name="username"
          label="名前"
          id="username"
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="password"
          type="password"
          id="password"
          onChange={handleChange}
        />
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={handleClickLogin}
        >
          ログイン
        </Button>
        <Link to="/register">新規登録はこちら</Link>
      </Box>
    </Container>
  );
};

export default Login;
